import React, {useEffect} from 'react';
import {UnauthorizedPage} from '@te-digi/styleguide';
import {useStore} from '@tanstack/react-store';
import useUser from '@common/tanstack-query/user/useUser';
import {useTranslation} from 'react-i18next';
import {
  tStore,
  updateApiData
} from '@common/tanstack-store/TanstackStoreProvider';
import {USER_STATUS} from '../ducks/user/constants';
import LoadingIndicator from './LoadingIndicator';
import endPoints from '@shared/ducks/user/sagas/profileEndpoints';
import {HP_COMMON_ID} from '@shared/i18next/i18next';

type Props = {
  children: React.ReactNode;
};

const EnsureUser = ({children}: Props) => {
  const apiPath = useStore(tStore, store => store.apiPath) || '';
  const {isLoading: isPending, error, data} = useUser({apiPath, endPoints});

  const {t} = useTranslation(HP_COMMON_ID);

  useEffect(() => {
    if (!isPending && data) {
      updateApiData({user: data});
    }
  }, [data, isPending]);

  const userState =
    data && !isPending && !error ? USER_STATUS.OK : USER_STATUS.FAILED;

  const userOk = userState === USER_STATUS.OK;
  const unauthorizedHeadingText = t('authorization_invalid');

  // Prevent flash of "no user" message while loading
  if (
    userState === USER_STATUS.LOADING ||
    userState === USER_STATUS.NOT_AVAILABLE ||
    isPending
  ) {
    return <LoadingIndicator center />;
  }

  return (
    <>
      {userOk ? (
        children
      ) : (
        <UnauthorizedPage heading={unauthorizedHeadingText} content={null} />
      )}
    </>
  );
};

export default EnsureUser;
